import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as packageJson from '../../package.json';
import { SENTRY_DSN, SENTRY_ENV } from '../helpers/constants';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  integrations: [new BrowserTracing()],
  release: `front@${packageJson.version}`,
  // ChunkLoadError is reported on purpose: it is how an outdated page shows up
  // (see the reload in public/index.html), and the only way to measure it.
  ignoreErrors: ['TypeError: Failed to fetch'],
});

export { Sentry };
